// eslint-disable-next-line no-unused-vars
// export const  randomArr ={
//     '0.50': 2,
//     '0.60': 1.5,
//     '0.70': 0.5,
//     '0.80': 0.5,
//     '0.90': 1.5,
//     '1.00': 1,
//     '1.10': 1,
//     '1.20': 1,
//     '1.30': 1.5,
//     '1.40': 1,
//     '1.50': 2,
//     '1.60': 2,
//     '1.70': 1,
//     '1.80': 0.5,
//     '1.90': 0.5,
//     '2.00': 1.5,
//     '2.10': 2,
//     '2.20': 0.5,
//     '2.30': 0.5,
//     '2.40': 1,
//     '2.50': 1.5,
//     '2.60': 0.5,
//     '2.70': 1.5,
//     '2.80': 1,
//     '2.90': 1.5,
//     '3.00': 0.5,
//     '3.10': 5,
//     '3.20': 0.5,
//     '3.30': 1.5,
//     '3.40': 1.5,
//     '3.50': 2,
//     '3.60': 2,
//     '3.70': 1.5,
//     '3.80': 1,
//     '3.90': 1,
//     '4.00': 2,
//     '4.10': 0.5,
//     '4.20': 1,
//     '4.30': 2,
//     '4.40': 5,
//     '4.50': 1.5,
//     '4.60': 1.5,
//     '4.70': 0.5,
//     '4.80': 2,
//     '4.90': 2,
//     '5.00': 2,
//     '5.10': 1.5,
//     '5.20': 2,
//     '5.30': 2,
//     '5.40': 1.5,
//     '5.50': 1,
//     '5.60': 1,
//     '5.70': 0.5,
//     '5.80': 2,
//     '5.90': 2,
//     '6.00': 1.5,
//     '6.10': 0.5,
//     '6.20': 1.5,
//     '6.30': 1.5,
//     '6.40': 2,
//     '6.50': 1,
//     '6.60': 1,
//     '6.70': 1.5,
//     '6.80': 0.5,
//     '6.90': 1,
//     '7.00': 1.5,
//     '7.10': 1,
//     '7.20': 0.5,
//     '7.30': 1,
//     '7.40': 2,
//     '7.50': 2,
//     '7.60': 1.5,
//     '7.70': 1,
//     '7.80': 2,
//     '7.90': 1,
//     '8.00': 1,
//     '8.10': 0.5,
//     '8.20': 2,
//     '8.30': 1.5,
//     '8.40': 1,
//     '8.50': 2,
//     '8.60': 0.5,
//     '8.70': 2,
//     '8.80': 0.5,
//     '8.90': 1,
//     '9.00': 2,
//     '9.10': 1.5,
//     '9.20': 0.5,
//     '9.30': 1,
//     '9.40': 1.5,
//     '9.50': 1,
//     '9.60': 1.5,
//     '9.70': 2,
//     '9.80': 2,
//     '9.90': 2,
//     '10.00': 1,
//     '10.10': 2,
//     '10.20': 1.5,
//     '10.30': 0.5,
//     '10.40': 2,
//     '10.50': 1,
//     '10.60': 2,
//     '10.70': 0.5,
//     '10.80': 1.5,
//     '10.90': 1,
//     '11.00': 1,
//     '11.10': 0.5,
//     '11.20': 0.5,
//     '11.30': 1,
//     '11.40': 1,
//     '11.50': 0.5,
//     '11.60': 1.5,
//     '11.70': 0.5,
//     '11.80': 1,
//     '11.90': 1.5,
//     '12.00': 2,
//     '12.10': 0.5,
//     '12.20': 1.5,
//     '12.30': 2,
//     '12.40': 1.5,
//     '12.50': 2,
//     '12.60': 0.5,
//     '12.70': 1.5,
//     '12.80': 1.5,
//     '12.90': 0.5,
//     '13.00': 0.5,
//     '13.10': 0.5,
//     '13.20': 2,
//     '13.30': 1,
//     '13.40': 1.5,
//     '13.50': 1.5,
//     '13.60': 1.5,
//     '13.70': 0.5,
//     '13.80': 0.5,
//    '13.90': 0.5,
//     '14.00': 1,
//     '14.10': 0.5,
//     '14.20': 0.5,
//     '14.30': 2,
//     '14.40': 0.5,
//     '14.50': 2,
//     '14.60': 0.5,
//     '14.70': 1.5,
//     '14.80': 0.5,
//     '14.90': 1,
//     '15.00': 1,
//     '15.10': 0.5,
//     '15.20': 1,
//     '15.30': 1.5,
//     '15.40': 0.5,
//     '15.50': 2,
//     '15.60': 2,
//     '15.70': 2,
//     '15.80': 2,
//     '15.90': 2,
//     '16.00': 1.5,
//     '16.10': 2,
//     '16.20': 1,
//     '16.30': 1,
//     '16.40': 1,
//     '16.50': 2,
//     '16.60': 1.5,
//     '16.70': 1.5,
//     '16.80': 1,
//     '16.90': 0.5,
//     '17.00': 0.5,
//     '17.10':0.5,
//     '17.20': 2,
//     '17.30': 2,
//     '17.40': 1.5,
//     '17.50': 1,
//     '17.60': 1,
//     '17.70': 2,
//     '17.80': 1.5,
//     '17.90': 1.5,
//     '18.00': 1.5,
//     '18.10': 1.5,
//     '18.20': 1.5,
//     '18.30': 1,
//     '18.40': 2,
//     '18.50': 0.5,
//     '18.60': 1,
//     '18.70': 0.5,
//     '18.80': 1.5,
//     '18.90': 1,
//     '19.00': 2,
//     '19.10': 0.5,
//     '19.20': 2,
//     '19.30': 1.5,
//     '19.40': 2,
//     '19.50': 1.5,
//     '19.60': 1,
//     '19.70': 2,
//     '19.80': 1.5,
//     '19.90': 1,
//     '20.00': 1,
//     '20.10': 1,
//     '20.20': 1,
//     '20.30': 0.5,
//     '20.40': 0.5,
//     '20.50': 1.5,
//     '20.60': 1.5,
//     '20.70': 1.5,
//     '20.80': 2,
//     '20.90': 1,
//     '21.00': 1,
//     '21.10': 0.5,
//     '21.20': 2,
//     '21.30': 1.5,
//     '21.40': 2,
//     '21.50': 1.5,
//     '21.60': 0.5,
//     '21.70': 1.5,
//     '21.80': 1,
//     '21.90': 1,
//     '22.00': 2,
//     '22.10': 2,
//     '22.20': 0.5,
//     '22.30': 2,
//     '22.40': 0.5,
//     '22.50': 1,
//     '22.60': 1,
//     '22.70': 1,
//     '22.80': 1,
//     '22.90': 1.5,
//     '23.00': 1,
//     '23.10': 2,
//     '23.20': 1.5,
//     '23.30': 0.5,
//     '23.40': 2,
//     '23.50': 0.5,
//     '23.60': 2,
//     '23.70': 0.5,
//     '23.80': 2,
//     '23.90': 1.5,
//     '24.00': 1,
//     '24.10': 0.5,
//     '24.20': 1,
//     '24.30': 0.5,
//     '24.40': 0.5,
//     '24.50': 1.5,
//     '24.60': 1,
//     '24.70': 2,
//     '24.80': 1,
//     '24.90': 2,
//     '25.00': 2,
//     '25.10': 1.5,
//     '25.20': 1,
//     '25.30': 2,
//     '25.40': 1.5,
//     '25.50': 0.5,
//     '25.60': 2,
//     '25.70': 1.5,
//     '25.80': 2,
//     '25.90': 2,
//     '26.00': 2,
//     '26.10': 0.5,
//     '26.20': 1.5,
//     '26.30': 1.5,
//     '26.40': 0.5,
//     '26.50': 0.5,
//     '26.60': 1.5,
//     '26.70': 2,
//     '26.80': 1,
//     '26.90': 2,
//     '27.00': 1,
//     '27.10': 1,
//     '27.20': 2,
//     '27.30': 1.5,
//     '27.40': 2,
//     '27.50': 2,
//     '27.60': 2,
//     '27.70': 1,
//     '27.80': 0.5,
//     '27.90': 2,
//     '28.00': 2,
//     '28.10': 1.5,
//     '28.20': 1,
//     '28.30': 2,
//     '28.40': 2,
//     '28.50': 1,
//     '28.60': 1,
//     '28.70': 1,
//     '28.80': 2,
//     '28.90': 1,
//     '29.00': 0.5,
//     '29.10': 2,
//     '29.20': 2,
//     '29.30': 1.5,
//     '29.40': 1.5,
//     '29.50': 2,
//     '29.60': 1,
//     '29.70': 1,
//     '29.80': 1.5,
//     '29.90': 0.5,
//     '30.00': 2,
//     '30.10': 1.5,
//     '30.20': 1.5,
//     '30.30': 1.5,
//     '30.40': 2,
//     '30.50': 1,
//     '30.60': 1,
//     '30.70': 2,
//     '30.80': 1.5,
//     '30.90': 0.5,
//     '31.00': 0.5,
//     '31.10': 2,
//     '31.20': 1,
//     '31.30': 0.5,
//     '31.40': 1,
//     '31.50': 1.5,
//     '31.60': 1.5,
//     '31.70': 2,
//     '31.80': 1.5,
//     '31.90': 0.5,
//     '32.00': 1.5,
//     '32.10': 2,
//     '32.20': 1,
//     '32.30': 1,
//     '32.40': 0.5,
//     '32.50': 0.5,
//     '32.60': 1,
//     '32.70': 0.5,
//     '32.80': 0.5,
//     '32.90': 0.5,
//     '33.00': 0.5,
//     '33.10': 1.5,
//     '33.20': 1.5,
//     '33.30': 1.5,
//     '33.40': 1,
//     '33.50': 1,
//     '33.60': 1,
//     '33.70': 2,
//     '33.80': 2,
//     '33.90': 1.5,
//     '34.00': 2,
//     '34.10': 1.5,
//     '34.20': 0.5,
//     '34.30': 1,
//     '34.40': 2,
//     '34.50': 1,
//     '34.60': 0.5,
//     '34.70': 1.5,
//     '34.80': 0.5,
//     '34.90': 1,
//     '35.00': 2,
//     '35.10': 2,
//     '35.20': 2,
//     '35.30': 1,
//     '35.40': 1,
//     '35.50': 2,
//     '35.60': 2,
//     '35.70': 0.5,
//     '35.80': 0.5,
//     '35.90': 2,
//     '36.00': 0.5,
//     '36.10': 0.5,
//     '36.20': 1.5,
//     '36.30': 1,
//     '36.40': 1.5,
//     '36.50': 1,
//     '36.60': 0.5,
//     '36.70': 2,
//     '36.80': 2,
//     '36.90': 2,
//     '37.00': 0.5,
//     '37.10': 1.5,
//     '37.20': 1.5,
//     '37.30': 0.5,
//     '37.40': 1,
//     '37.50': 0.5,
//     '37.60': 2,
//     '37.70': 1.5,
//     '37.80': 2,
//     '37.90': 1.5,
//     '38.00': 1,
//     '38.10': 2,
//     '38.20': 2,
//     '38.30': 1,
//     '38.40': 1,
//     '38.50': 1,
//     '38.60': 2,
//     '38.70': 1.5,
//     '38.80': 1.5,
//     '38.90': 0.5,
//     '39.00': 1,
//     '39.10': 0.5,
//     '39.20': 1,
//     '39.30': 1.5,
//     '39.40': 1.5,
//     '39.50': 1.5,
//     '39.60': 1,
//     '39.70': 0.5,
//     '39.80': 1,
//     '39.90': 1,
//     '40.00': 1,
//     '40.10': 1,
//     '40.20': 1,
//     '40.30': 0.5,
//     '40.40': 1,
//     '40.50': 1,
//     '40.60': 2,
//     '40.70': 2,
//     '40.80': 1,
//     '40.90': 1.5,
//     '41.00': 1,
//     '41.10': 0.5,
//     '41.20': 2,
//     '41.30': 1.5,
//     '41.40': 2,
//     '41.50': 2,
//     '41.60': 1,
//     '41.70': 1.5,
//     '41.80': 0.5,
//     '41.90': 1,
//     '42.00': 1,
//     '42.10': 0.5,
//     '42.20': 2,
//     '42.30': 2,
//     '42.40': 1.5,
//     '42.50': 1.5,
//     '42.60': 0.5,
//     '42.70': 0.5,
//     '42.80': 1,
//     '42.90': 1.5,
//     '43.00': 1.5,
//     '43.10': 1,
//     '43.20': 0.5,
//     '43.30': 1,
//     '43.40': 1,
//     '43.50': 2,
//     '43.60': 1,
//     '43.70': 2,
//     '43.80': 1,
//     '43.90': 1.5,
//     '44.00': 2,
//     '44.10': 1,
//     '44.20': 1.5,
//     '44.30': 1.5,
//     '44.40': 0.5,
//     '44.50': 1.5,
//     '44.60': 0.5,
//     '44.70': 2,
//     '44.80': 0.5,
//     '44.90': 1.5,
//     '45.00': 2,
//     '45.10': 1,
//     '45.20': 1,
//     '45.30': 0.5,
//     '45.40': 2,
//     '45.50': 2,
//     '45.60': 2,
//     '45.70': 1,
//     '45.80': 0.5,
//     '45.90': 0.5,
//     '46.00': 2,
//     '46.10': 1.5,
//     '46.20': 2,
//     '46.30': 1.5,
//     '46.40': 1.5,
//     '46.50': 0.5,
//     '46.60': 1.5,
//     '46.70': 0.5,
//     '46.80': 2,
//     '46.90': 1,
//     '47.00': 2,
//     '47.10': 0.5,
//     '47.20': 2,
//     '47.30': 1.5,
//     '47.40': 0.5,
//     '47.50': 1.5,
//     '47.60': 2,
//     '47.70': 2,
//     '47.80': 1.5,
//     '47.90': 2,
//     '48.00': 1.5,
//     '48.10': 1.5,
//     '48.20': 1.5,
//     '48.30': 2,
//     '48.40': 2,
//     '48.50': 0.5,
//     '48.60': 1.5,
//     '48.70': 0.5,
//     '48.80': 1,
//     '48.90': 1.5,
//     '49.00': 2,
//     '49.10': 2,
//     '49.20': 1.5,
//     '49.30': 2,
//     '49.40': 0.5,
//     '49.50': 0.5,
//     '49.60': 2,
//     '49.70': 1,
//     '49.80': 1.5,
//     '49.90': 2,
//     '50.00': 2,
// };


export const randomArr = {
    '0': 0.2,
    '10': 1.1,
    '20': 0.5,
    '30': 0.5,
    '40': 1.1,
    '50': 1.3,
    '60': 1,
    '70': 0.6,
    '80': 0.5,
    '90': 1.1,
    '100': 0.2,
    '110': 0.5,
    '120': 1,
    '130': 0.7,
    '140': 0.5,
    '150': 0.2,
    '160': 0.2,
    '170': 0.5,
    '180': 0.5,
    '190': 0.1,
    '200': 0.5,
    '210': 0.5,
    '220': 1.5,
    '230': 0.1,
    '240': 0.5,
    '250': 0.5,
    '260': 0.5,
    '270': 0.5,
    '280': 0.5,
    '290': 0.5,
    '300': 0.2,
    '310': 0.2,
    '320': 1.5,
    '330': 0.1,
    '340': 0.1,
    '350': 1,
    '360': 0.5,
    '370': 0.1,
    '380': 0.2,
    '390': 0.5,
    '400': 0.5,
    '410': 0.5,
    '420': 0.5,
    '430': 0.2,
    '440': 1.2,
    '450': 0.2,
    '460': 0.5,
    '470': 0.2,
    '480': 0.2,
    '490': 0.5,
    '500': 1,
    '510': 0.1,
    '520': 0.5,
    '530': 1.2,
    '540': 0.2,
    '550': 1.5,
    '560': 0.5,
    '570': 0.5,
    '580': 0.5,
    '590': 1.1,
    '600': 1,
    '610': 1,
    '620': 0.5,
    '630': 0.5,
    '640': 1,
    '650': 0.5,
    '660': 1,
    '670': 0.5,
    '680': 1,
    '690': 0.2,
    '700': 0.2,
    '710': 1.5,
    '720': 1,
    '730': 0.2,
    '740': 1,
    '750': 1,
    '760': 0.5,
    '770': 1.2,
    '780': 0.5,
    '790': 1,
    '800': 0.2,
    '810': 0.5,
    '820': 0.2,
    '830': 0.5,
    '840': 0.5,
    '850': 0.5,
    '860': 1,
    '870': 0.5,
    '880': 1,
    '890': 0.5,
    '900': 1,

    '910': 0.5,
    '920': 1,
    '930': 0.2,
    '940': 1,
    '950': 1,
    '960': 0.5,
    '970': 0.2,
    '980': 0.5,
    '990': 1,
    '1000': 1.2,
    '1010': 0.5,
    '1020': 2,
    '1030': 0.5,
    '1040': 1.5,
    '1050': 0.5,
    '1060': 1,
    '1070': 0.5,
    '1080': 1,
    '1090': 0.5,
    '1100': 1,

    '1110': 0.5,
    '1120': 1.2,
    '1130': 0.5,
    '1140': 1.5,
    '1150': 0.5,
    '1160': 1.1,
    '1170': 0.5,
    '1180': 1.1,
    '1190': 1.05,
    '1200': 0.2,

    '1210': 1.01,
    '1220': 1.2,
    '1230': 1.2,
    '1240': 1.2,
    '1250': 0.2,
    '1260': 1.2,
    '1270': 0.5,
    '1280': 0.1,
    '1290': 1.3,
    '1300': 1.2,

    '1310': 0.5,
    '1320': 1,
    '1330': 1.2,
    '1340': 1.1,
    '1350': 1.1,
    '1360': 1.2,
    '1370': 1.2,
    '1380': 1.5,
    '1390': 1,
    '1400': 1.2,
    '1410': 1.5,
    '1420': 1.3,
    '1430': 1.2,
    '1440': 1.2,
    '1450': 1.1,
    '1460': 0.5,
    '1470': 1.5,
    '1480': 1.1,
    '1490': 1.2,
    '1500': 1.1,
}
